import { type MaybeRefOrGetter, toRef, toValue } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import type { MessageInputMethod } from '~/api/shopping-assistant/types'

const TRACKING_ZONE = 'ai_shopping_assistant'

export function useShoppingAssistantTracking(
  id: MaybeRefOrGetter<string | null>,
) {
  const {
    trackFormSubmit,
    trackScreenView,
    trackClick,
    trackProductClick,
    trackShoppingAssistantMessageSent,
    trackShoppingAssistantChatReady,
    trackShoppingAssistantProductClick,
  } = useTracking()

  const chatId = toRef(() => toValue(id) || '')

  function trackChatReady() {
    trackShoppingAssistantChatReady({ chatId: chatId.value })
    trackScreenView({
      screenType: 'ai_chat_started',
      zone: TRACKING_ZONE,
      chatId: chatId.value,
    })
  }

  function trackMessageSent({
    inputMethod,
  }: {
    inputMethod: MessageInputMethod
  }) {
    trackShoppingAssistantMessageSent({
      chatId: chatId.value,
      inputMethod,
    })
    trackFormSubmit({
      zone: TRACKING_ZONE,
      name: 'ai_chat_message_sent',
      chatId: chatId.value,
      inputMethod,
    })
  }

  function trackProductClicked({ position = 1 }: { position?: number }) {
    trackProductClick({
      list: TRACKING_ZONE,
      source: 'ai_shopping_assistant_recommendation',
      position,
    })

    trackShoppingAssistantProductClick({
      // FIXME pass the product once the API returns the expected format
      chatId: chatId.value,
    })
  }

  function trackClicked(payload: Record<string, unknown>) {
    trackClick({
      ...payload,
      zone: TRACKING_ZONE,
      chatId: chatId.value,
    })
  }

  return {
    trackChatReady,
    trackMessageSent,
    trackProductClicked,
    trackClicked,
  }
}
